import { Row } from 'app/design/primitives/box';
import { createTheme as createDSTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconNotes } from '@tabler/icons-react-native';
import React from 'react';

const theme = createDSTheme();

export const BonificationBadge = ({ absolute = true }: { absolute?: boolean }) => (
  <Row
    position={absolute ? 'absolute' : 'relative'}
    top={0}
    right={0}
    alignItems="center"
    gap="spacing.general.x2"
    zIndex={1}
    style={{
      backgroundColor: theme.colors['surface.warning.subtle'],
      borderRadius: 999,
      padding: theme.spacing['spacing.general.x0,5'],
    }}
  >
    <IconNotes strokeWidth={ICON_STROKE_WIDTH} size={18} color={theme.colors['text.primary']} />
  </Row>
);
